import React, {useState} from 'react';
import round from 'lodash/round';
import moment from 'moment';
import {useNavigate} from 'react-router-dom';

import useUser from '../../hooks/useUser';
import AppDashboard from '../AppDashboard';
import CalendarScreen from '../../components/calendar/CalendarScreen';
import { useGetSessionsQuery } from '../../redux/services/sessionApi';

const getStartAndEndDate = ({date, calendarView}) => {
  if (calendarView === 'week') {
    return {
      startDate: moment(date).startOf('week').toISOString(),
      endDate: moment(date).endOf('week').toISOString(),
    };
  }
};

const ProviderCalendarPage = () => {
  const [date, setDate] = useState(new Date());
  const [calendarView, setCalendarView] = useState('week');
  const user = useUser();
  const {startDate, endDate} = getStartAndEndDate({date, calendarView});
  const childProps = {
    loading: !user,
  };
  const query = {
    provider_id: user?.provider?.id,
    start_time: startDate, 
    end_time: endDate,
    limit: 100,
  };
  const sessionQuery = useGetSessionsQuery(query);
  const sessions = sessionQuery?.data?.data || [];
  const metrics = !sessions || !sessions.length ? [] : [
    {
      label: 'Total Sessions', 
      value: sessions.length
    },
    {
      label: 'Total Care Hours', 
      value: round(sessions.reduce((acc, s) => acc + s.duration, 0) / 60, 1),
    },
  ];
  return (
    <AppDashboard 
      loading={childProps.loading} 
      error={childProps.error} 
    >
      <CalendarScreen
        calendarView={calendarView}
        date={date}
        sessions={sessions}
        metrics={metrics}
        onDateChange={(e, date) => setDate(date)}
        onCalendarViewChange={(e, view) => setCalendarView(view)}
      />
    </AppDashboard>
  );
};

export default ProviderCalendarPage;